// extracted by mini-css-extract-plugin
export default {"btn-container":"ErrorAlert___ErrorAlert-module__btn-container___pN5Fb"};